/*
 * File: d:\projects\AutoFiFront\src\Content\Financement\Financement.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday March 29th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday March 29th 2023 5:25:54 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { useState } from 'react';
import translator from 'MultiLanguage/TranslationWrapper';
import styles from "Content/Financement/Financement.module.css";
import RentingTool from 'Content/RentingTool/RentingTool';
import CollapseBox2 from 'Content/CollapseBox/CollapseBox2';
import { NavLink } from 'react-router-dom';
import RouterPathResolver from 'Config/Router/RouterPathResolver';

function Financement (_: any) {
    const financeOption = ["loa", "lld", "cb", "newOrUsed", "solution"];
    const [simulationData, setSimulationData] = useState<{mileage: number, contribution: number, monthsNB: number, rentalCost: number}>();

    return (
        <React.Fragment>
            <div className={`${styles.heading}`}>
                <h1> <span className={`${styles.textThemeColor}`}> {translator.decode("financementText.titlePart1")} </span> {translator.decode("financementText.titlePart2")}</h1>
                <div className={`${styles.headingText}`}>
                    <img className={`${styles.headingImg}`} src="/2carvide2.png" alt="image d'une voiture"/>
                    <p>{translator.decode("financementText.text")}</p>
                </div>
            </div>
            <div className={`${styles.rules}`}>
                <div className={`${styles.rulesTextHolder}`}>
                    <div>
                        {translator.decode(`financementPage.rules.intro`)}<span className={`${styles.simulationValue}`}>36 000€</span>
                    </div>
                    <div>
                        {translator.decode(`financementPage.rules.I`)} <span className={`${styles.simulationValue}`}>{simulationData?.contribution} €</span>
                    </div>
                    <div>
                        {translator.decode(`financementPage.rules.II`)} <span className={`${styles.simulationValue}`}>{simulationData?.monthsNB} {translator.decode(`pricing.month`)}</span>
                    </div>
                    <div>
                        {translator.decode(`financementPage.rules.III`)} <span className={`${styles.simulationValue}`}>{simulationData?.mileage} {translator.decode("pricing.mileage")}/{translator.decode("pricing.year")}</span>
                    </div>
                </div>
                <RentingTool setSimulation={setSimulationData} border={1} SellPrice={36000} Mileage={15000} Contribution={2500} MonthsNb={36} bgColor={'neutre'} />
            </div>
            <div className={`${styles.descriptionHolder}`}>
                {
                    financeOption.map((item: string, index: number)=>{ return <CollapseBox2 context={item} key={`${item}+${index}`}/> })
                }
                <NavLink className={`${styles.btnGoTo}`} to={RouterPathResolver.routeFinanceFaq.path}> <div> {translator.decode("financementPage.faq")} </div> </NavLink>
            </div>
        </React.Fragment>
    );
}

export default Financement;
